<template>
    <div>
        <button class="btnAction  btn_link">
            <span>QUALITE</span>
            <svg width="10" height="8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M1.175.5L5 4.827 8.825.5 10 1.832 5 7.5 0 1.832 1.175.5z" fill="#313131"></path>
            </svg>
        </button>
        <div class="card smallCard">
            <div class="QualitySection my-10">
                <button v-for="(level, index) in qualityLevels" :key="index" class="QualityBtn card_btn"
                    :class="{ 'active' : (index+1) == activeRate }" v-on:click="changeRate(index+1)">
                    <span class="quality">{{level?.height}}p</span>
                </button>
                <button class="QualityBtn card_btn"
                    :class="{ 'active' : activeRate == -1 }" v-on:click="changeRate(-1)">
                    <span class="quality">AUTO</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name: 'RateSection',
    components: {

    },
    props: {
        player: {
            type: Object
        },
        currentQualityIndex: {
            type: Function
        },
    },
    data() {
        return {
            qualityLevels: [],
            activeRate: -1,
            changeRate: (i) => {
                this.activeRate = i;
                this.currentQualityIndex(i);
                console.log("current quality index is ", i);
                if(i>-1) {
                    this.player.hlsQualitySelector.setQuality(this.qualityLevels[i-1].height);
                } else {
                    this.player.hlsQualitySelector.setQuality("auto");
                }
                
            }
        }
    },
    mounted() {
        // this.qualityLevels = this.player.qualityLevels().levels_;
        // this.player.loadSource("https://stream-vod.webtv-solution.com/ovh/hls/parcoursmetiers/mp4/prn44_jf19_1442_,4000,1500,850,450,250,.mp4.csmil/index-f4-v1-a1.m3u8");
        this.qualityLevels = this.player.qualityLevels().levels_;
        this.activeRate = this.currentQualityIndex();
        console.log("onload quality index is ", this.activeRate);
        // console.log("reps are: ", this.player.hls.representations());
        // console.log(this.player.manifest.playlists[3])
    }
}
</script>
<style>
.QualitySection {
    display: flex;
    justify-content: space-around;
    margin: 5px 0px 10px 0px;
}

.QualitySection .QualityBtn {
    margin: 0 10px;
    cursor: pointer;
    position: relative;
}

.QualitySection .QualityBtn.tagged {
    padding-right: 30px !important;
}

.QualitySection .QualityBtn .taggedQuality {
    position: absolute;
    font-size: 8px;
    z-index: 5;
    top: 0px;
    right: 1px;
    font-weight: 900;
}

.QualitySection .QualityBtn .quality {
    position: absolute;
    font-size: 13px;
    z-index: 5;
    top: 3px;
    right: 13px;
    font-family: "Open Sans";
}

@media screen and (max-width: 576px) {
    .QualitySection {
        display: flex;
        justify-content: space-around;
    }

    .QualitySection .QualityBtn {
        margin: 0 0px;
        cursor: pointer;
        position: relative;
    }

    .QualitySection .QualityBtn .quality {
        font-size: 9px;
        top: 6px;
        right: 7px;
    }
}
</style>